import { useState } from "react";
import { Eye, Download, History, ChevronDown, ChevronUp } from "lucide-react";

const KIND = { "24h": "24h antes", "2h": "2h antes", manual: "Enviar agora", update: "Atualização" };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : null);

function CaptainSeen({ seen }) {
  if (!seen) return null;
  const ok = seen.downloaded_at || seen.opened_at;
  return (
    <div className="flex flex-wrap items-center gap-3 text-xs" data-testid="captain-seen">
      <span className="kw-overline text-[10px]">Capitão</span>
      {!seen.received && <span className="text-[#737373]">Ainda não recebeu a apresentação</span>}
      {seen.received && !ok && <span className="text-[#EAB308]">Recebeu, ainda não abriu</span>}
      {seen.opened_at && <span className="inline-flex items-center gap-1 text-[#00FF88]"><Eye className="w-3 h-3" /> Abriu o email {fmt(seen.opened_at)}</span>}
      {seen.downloaded_at && <span className="inline-flex items-center gap-1 text-[#00FF88]"><Download className="w-3 h-3" /> Descarregou {fmt(seen.downloaded_at)}</span>}
    </div>
  );
}

export function SendLog({ sends, hasCaptain }) {
  const [open, setOpen] = useState(false);
  const log = sends.log || [];
  return (
    <div className="border-t border-[#222] pt-3 space-y-2" data-testid="send-log">
      {hasCaptain && <CaptainSeen seen={sends.captain_seen} />}
      <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-1 text-xs text-[#A3A3A3] hover:text-white"
        data-testid="send-log-toggle">
        <History className="w-3 h-3" /> Histórico de envios ({log.length}) {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
      </button>
      {open && (log.length ? (
        <ul className="text-[11px] space-y-1" data-testid="send-log-list">
          {log.map((x) => (
            <li key={x.id} className="flex flex-wrap gap-x-3 text-[#A3A3A3]">
              <span className="text-white">{fmt(x.sent_at)}</span>
              <span>{KIND[x.kind] || x.kind}</span>
              <span>{x.role}: {x.name || x.email}</span>
              <span>{x.has_material ? "QR + apresentação" : "só QR"}</span>
              {!x.ok && <span className="text-[#FF6B6B]">falhou</span>}
              {x.opened_at && <span className="text-[#00FF88]">abriu</span>}
              {x.downloaded_at && <span className="text-[#00FF88]">descarregou</span>}
            </li>
          ))}
        </ul>
      ) : <div className="text-[11px] text-[#555]">Ainda não foi enviado nada para esta sessão.</div>)}
    </div>
  );
}
